import React from 'react';
import { motion } from 'framer-motion';
export function Problem() {
  return <section className="py-20 bg-brand-cream px-6" data-id="element-188">
      <div className="max-w-3xl mx-auto" data-id="element-189">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-190">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-191">
            Cuando la lógica no existe
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-brand-navy/80 leading-relaxed" data-id="element-192">
            <p data-id="element-193">
              La mayoría de los libros de crianza te dicen que "respires
              profundo" o que "ignores la conducta". Pero seamos honestas:
              cuando tu hijo está en medio de una crisis sensorial, la lógica no
              existe.
            </p>

            <p data-id="element-194">
              Su cerebro está en llamas. Su sistema de "lucha o huida" ha tomado
              el control total. En ese momento, cada palabra que dices, cada
              explicación que intentas dar y cada amenaza de "quitarle la
              tablet" solo echa más gasolina al fuego.
            </p>

            <blockquote className="my-12 border-l-4 border-brand-coral pl-6 py-2" data-id="element-195">
              <p className="font-serif text-2xl md:text-3xl italic text-brand-navy font-medium leading-snug" data-id="element-196">
                "Estás intentando razonar con un incendio forestal."
              </p>
            </blockquote>

            <p data-id="element-197">
              No es que no te escuche. Es que su cerebro no puede procesar el
              lenguaje en ese estado. El resultado siempre es el mismo: él
              termina agotado y tú terminas llorando en el baño, sintiéndote la
              peor madre del mundo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}